export default __webpack_public_path__ + "static/media/chat-icon.d4edb1a9.svg";